<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    {{ grade | toFriendlyGrade  }}
    <feather-icon v-if="isIncluded && grade" icon="SlashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openExcludeConfirm" />
    <feather-icon v-if="isExcluded && grade" icon="PlusIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openIncludeConfirm" />
  </div>
</template>

<script>
export default {
  name: 'CellSampleActions',
  computed: {
    grade() {
      return this.params.value.grade
    },
    isExcluded() {
      return this.params.value.isExcluded;
    },
    isIncluded() {
      return !this.params.value.isExcluded;
    }
  },
  methods: {
    openIncludeConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: name,
        text: this.$t('GradeControl.Sample.ConfirmInclusion'),
        accept: this.includeSample
      });
    },

    openExcludeConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name,
        text: this.$t('GradeControl.Sample.ConfirmExclusion'),
        accept: this.excludeSample
      });
    },

    excludeSample () {
      this.params.value.isExcluded = true;
      this.params.context.componentParent.updateSampleResult(this.params.value);
    },

    includeSample () {
      this.params.value.isExcluded = false;
      this.params.context.componentParent.updateSampleResult(this.params.value);
    }
  }
}
</script>
